import React from 'react';

function Top(props) {
    const className = props.className;
    const fill = props.fill;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="none" 
            className={className}
        >
            <path 
                d="M13.3661 8.56197L13.3834 8.5765C13.742 8.8849 13.7911 9.42476 13.4901 9.79315C13.1892 10.1615 12.6503 10.2211 12.2766 9.9313L12.2589 9.9172L7.96633 6.41043L3.1979 9.94269C2.80959 10.2303 2.26163 10.1487 1.97399 9.7604C1.68635 9.37208 1.76796 8.82412 2.15628 8.53648L8.01895 4.19366L13.3661 8.56197Z" 
                fill={fill}
            />
            <path 
                d="M14.125 1C14.6082 1 15 1.39175 15 1.875C15 2.35825 14.6082 2.75 14.125 2.75H1.875C1.39175 2.75 1 2.35825 1 1.875C1 1.39175 1.39175 1 1.875 1H14.125Z" 
                fill={fill}
            />
            <path 
                d="M14.125 13.25C14.6082 13.25 15 13.6418 15 14.125C15 14.6082 14.6082 15 14.125 15H1.875C1.39175 15 1 14.6082 1 14.125C1 13.6418 1.39175 13.25 1.875 13.25H14.125Z" 
                fill={fill}
            />
        </svg>
    )
};

export default Top;